import type { KbPermission } from "@/api/types";
import { useAuth } from "@/auth/useAuth";

import type { ActionValue } from "./actions";
import { can } from "./can";

type Resource =
  | { team_id: string }
  | { owner_team_id: string; kb_permission?: KbPermission | null }
  | { owner_team_id: string; created_by_user_id?: string }
  | string;

export function useCan(action: ActionValue, resource?: Resource): boolean {
  const { user, memberships } = useAuth();
  return can(user, memberships, action, resource);
}
